import { useEffect, useState } from "react";

const BASE_URL = "https://eventos.utpl.edu.ec/";

const Fetcher = ({ url, children }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Obtener UNA imagen
  const getImageUrl = (node, included, fieldName) => {
    const mediaId = node?.relationships?.[fieldName]?.data?.id;
    if (!mediaId) return null;

    const media = included.find(
      (item) => item.type === "media--image" && item.id === mediaId
    );

    const fileId = media?.relationships?.field_media_image?.data?.id;
    if (!fileId) return null;

    const file = included.find(
      (item) => item.type === "file--file" && item.id === fileId
    );

    return file?.attributes?.uri?.url
      ? BASE_URL + file.attributes.uri.url
      : null;
  };

  // Obtener MUCHAS imágenes
  const getImageUrls = (node, included, fieldName) => {
    const mediaItems = node?.relationships?.[fieldName]?.data;
    if (!Array.isArray(mediaItems)) return [];

    return mediaItems
      .map((item) => {
        const media = included.find(
          (inc) => inc.type === "media--image" && inc.id === item.id
        );
        const fileId = media?.relationships?.field_media_image?.data?.id;
        const file = included.find(
          (inc) => inc.type === "file--file" && inc.id === fileId
        );
        return file?.attributes?.uri?.url
          ? BASE_URL + file.attributes.uri.url
          : null;
      })
      .filter(Boolean);
  };

  // Obtener DOCUMENTO
  const getDocumentUrl = (node, included, fieldName) => {
    const mediaId = node?.relationships?.[fieldName]?.data?.id;
    if (!mediaId) return null;

    const media = included.find(
      (item) => item.type === "media--document" && item.id === mediaId
    );
    const fileId = media?.relationships?.field_media_document?.data?.id;
    if (!fileId) return null;

    const file = included.find(
      (item) => item.type === "file--file" && item.id === fileId
    );

    return file?.attributes?.uri?.url
      ? BASE_URL + file.attributes.uri.url
      : null;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!url) throw new Error("URL no proporcionada");

        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`Error ${response.status}`);
        }

        const json = await response.json();
        const node = Array.isArray(json?.data) ? json.data[0] : json.data;
        const atributos = node?.attributes;
        const included = json?.included || [];

        if (!atributos) {
          throw new Error("Estructura inesperada de la API");
        }

        // Automatizar bloques
        const bloques = {};
        for (let i = 1; i <= 30; i++) {
          bloques[`bloque${i}`] =
            atributos[`field_bloque${i}`]?.processed || "";
        }

        // Automatizar imágenes
        const imagenes = {};
        for (let i = 1; i <= 30; i++) {
          imagenes[`imagen${i}`] =
            getImageUrl(node, included, `field_imagen${i}`) || "";
        }

        const cleanData = {
          id: node.id,
          titulo: atributos.title,
          ponente: atributos.field_ponente,
          texto_portada: atributos.field_texto_portada?.processed || "",
          imagen_portada: getImageUrl(node, included, "field_portada") || "",
          ...bloques,
          ...imagenes,
          galeria: getImageUrls(node, included, "field_gallery"),
          documento1: getDocumentUrl(node, included, "field_documento_1"),
          documento2: getDocumentUrl(node, included, "field_documento_2"),
        };

        setData(cleanData);
      } catch (err) {
        console.error("FETCH ERROR:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [url]);

  if (loading) return <p className="text-center py-10 font-semibold text-slate-500">Cargando evento...</p>;
  if (error) return <p className="text-center py-10 text-red-600 font-semibold">Error: {error}</p>;

  return children(data);
};

export default Fetcher;